import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getSessionById } from '../../redux/features/sessions/sessionActions'
import { useNavigate } from 'react-router-dom';

function Card({ data }) {
    const dispatch = useDispatch();
    const [eventsData, setEventsData] = useState([]);

    const navigate = useNavigate()

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const fetchedEvents = await Promise.all(
                    data?.events?.map(async (element) => {
                        const res = await dispatch(getSessionById({ eventId: element.eventId })).unwrap();
                        return res?.event;
                    })
                );
                setEventsData(fetchedEvents);
            } catch (err) {
                const errorMessage = err.error || 'Failed to fetch session data';
                // message.error(errorMessage);
            }
        };

        fetchEvents();
    }, [data, dispatch]);

    // const selectSession = (id) => {
    //     const type = true
    //     const isfilter = ''
    //     navigate(`/session/video/${id}/${type}/${isfilter}`);
    // }

    return (
        <>
            <div class="font-poppins bg-background-primary-color">
                <div class="p-4 mx-auto lg:max-w-full sm:max-w-full">
                    <h2 class="text-2xl font-bold text-gray-200 mb-12">Other sessions</h2>

                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 max-xl:gap-4 gap-6">
                        {eventsData.map((event) => (
                            <div class="bg-background-secondary-color rounded-2xl p-5 cursor-pointer hover:-translate-y-2 transition-all relative">
                                <div className="w-full aspect-w-16 aspect-h-8  rounded-xl mb-3">
                                    <img
                                        src={event?.coverImage[0]?.url}
                                        alt={event?.event_name}
                                        className="h-full w-full object-container object-top rounded-lg "
                                    />
                                </div>



                                <div>
                                    <h3 class="text-lg font-bold text-gray-200">{event?.event_name}</h3>
                                    <p class="text-red-600 text-sm mt-1">{event?.presenter}</p>
                                    <p class="text-gray-400 text-sm mt-1">#{event?.category}</p>
                                    <p class="text-gray-200 text-sm mt-1">Status:{event?.event_status}</p>
                                </div>

                            </div>

                        ))}
                    </div>

                </div>
            </div>
        </>
    )
}

export default Card